import { Rule } from "shared/app/VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/types";
import { Card } from "shared/components/Card";
import { Applicant } from "types/application";
import { RuleConditionRow } from "./RuleConditionRow";
import { HugeiconsIcon } from "@hugeicons/react";
import { Search01Icon } from "@hugeicons-pro/core-stroke-rounded";

interface WhatToReviewProps {
  surfacedRules: Rule[];
  applicants: Applicant[];
}

export const WhatToReview = ({
  surfacedRules,
  applicants
}: WhatToReviewProps) => {
  return (
    <Card className="mt-4">
      <div className="px-6 py-4 border-b border-alpha-40 flex items-center gap-2">
        <HugeiconsIcon
          icon={Search01Icon}
          className="text-content-1000"
          size={20}
        />
        <h2 className="text-sm font-bold text-content-1000">What to review</h2>
      </div>
      <div className="p-4 space-y-3">
        {surfacedRules.map((rule, index) => (
          <RuleConditionRow
            key={`${rule.field_name}-${index}`}
            rule={rule}
            applicants={applicants}
            showStatusBadge={false}
          />
        ))}
      </div>
    </Card>
  );
};
